export enum EMeetingPoint {
  RENTAL_STATION = "RENTAL_STATION",
  AIRPORT = "AIRPORT",
}

export enum EMeetingPointAirport {
  FLIGHT = "FLIGHT",
  NO_FLIGHT = "NO_FLIGHT",
}

export enum ETerminal {
  T1 = "T1",
  T2 = "T2",
  T3 = "T3",
  T4 = "T4",
  T5 = "T5",
}
